<template>
  <div id="compliance-list-loading" class="vs-con-loading__container">
    <pdf-reader />
    <div v-show="hasPermission(['IU COMPLIANCE VIEW'])">
      <vx-card
        noShadow
        ref="filterCard"
        :title="$t('filters')"
        class="user-list-filters mb-8"
      >
        <template slot="actions">
          <feather-icon
            @click="search('compliance.id')"
            icon="FilterIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          />
          <feather-icon
            @click="resetFilters"
            icon="TrashIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          />
        </template>
        <div class="vx-row mx-2">
          <div class="vx-col md:w-1/3 sm:w-1 w-full">
            <label class="text-sm opacity-75">{{ $t('client') }}</label>
            <v-select
              multiple
              v-model="params.client_id"
              :options="clientFilter"
              :reduce="(client) => client.ClientId"
              label="ShortName"
              v-validate="'required'"
              name="filterClient"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 sm:w-1 w-full">
            <label class="text-sm opacity-75">{{ $t('document') }}</label>
            <v-select
              multiple
              v-model="params.title_id"
              :options="titles"
              :reduce="(title) => title.id"
              label="name"
              v-validate="'required'"
              name="filterTitle"
              class="w-full"
            />
          </div>
          <div class="vx-col md:w-1/3 sm:w-1 w-full">
            <label class="text-sm opacity-75">{{ $t('status') }}</label>
            <v-select
              multiple
              v-model="params.status_id"
              :options="statusFilterState"
              :reduce="(status) => status.id"
              label="name"
              v-validate="'required'"
              name="filterStatus"
              class="w-full"
            />
          </div>
        </div>
      </vx-card>
      <vx-card noShadow :title="$t('status_compliance_details')">
        <template slot="actions">
          <vs-row>
            <div class="vx-col w-full px-1 mb-4 md:w-1/3" v-if="allowEditing">
              <!-- <vs-button
                @click="addCompliance"
                color="success"
                type="filled"
                class="w-full"
                icon-pack="feather"
                icon="icon-plus"
                >{{ $t('add') }} {{ $t('new') }}</vs-button
              > -->
              <add-button @click="addCompliance" />
            </div>
            <div
              class="vx-col w-full px-1 mb-4"
              :class="[allowEditing ? 'md:w-1/3' : 'md:w-1/2']"
            >
              <vs-input
                icon="search"
                :placeholder="$t('search')"
                class="w-full"
                v-model="params.search"
                @keypress.enter="search('compliance.id')"
              />
            </div>
            <div
              class="vx-col w-full px-1 mb-4"
              :class="[allowEditing ? 'md:w-1/3' : 'md:w-1/2']"
            >
              <export-button
                :data="this.params"
                :url="'compliance/export_csv/82s8WsuiaaSiE28sS__SruSQq247___6as8'"
                :type="name_report"
              />
            </div>
          </vs-row>
        </template>
        <add-compliance
          :clients="clients"
          :facilities="facilities"
          :categories="categories"
          :vendors="vendors"
          :titles="titles"
          :frequencies="frequencies"
        />
        <validate-compliance
          :clients="clients"
          :facilities="facilities"
          :categories="categories"
          :vendors="vendors"
          :titles="titles"
          :compliance="compliance"
        />
        <update-compliance-expiration :compliance="compliance" />
        <show-compliance :compliance="compliance" />
        <edit-insurance :data="compliance" :vendors="vendors" />
        <pdf-viewer />
        <vs-row>
          <div class="vx-col w-full">
            <vs-table
              stripe
              class="fixedHead text-left w-full"
              :data="complianceList"
            >
              <!-- filteredData -->
              <template slot="thead">
                <th
                  width="250px"
                  @click="search('c.ClientName'), sortBy('c.ClientName')"
                >
                  {{ $t('client') }}
                  <span
                    v-if="this.sortOrders['c.ClientName'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th width="250px" @click="search('f.Name'), sortBy('f.Name')">
                  {{ $t('building_number') }}
                  <span
                    v-if="this.sortOrders['f.Name'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <!-- no trans -->
                <th width="200px" @click="search('cc.name'), sortBy('cc.name')">
                  {{ $tc('type')|capitalize }}
                  <span
                    v-if="this.sortOrders['cc.name'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <!-- no trans -->
                <th
                  width="200px"
                  @click="search('v.VendorName'), sortBy('v.VendorName')"
                >
                  {{ $t('vendor') }}
                  <span
                    v-if="this.sortOrders['v.VendorName'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <!-- no trans -->
                <th width="200px" @click="search('ct.name'), sortBy('ct.name')">
                  {{ $t('document') }}
                  <span
                    v-if="this.sortOrders['ct.name'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <!-- no trans -->
                <!--<th width="200px">{{$t('document_date')}}</th> no trans -->
                <th width="200px" @click="search('cs.name'), sortBy('cs.name')">
                  {{ $t('status') }}
                  <span
                    v-if="this.sortOrders['cs.name'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th
                  width="120px"
                  @click="
                    search('compliance.expiration_date'),
                      sortBy('compliance.expiration_date')
                  "
                >
                  {{ $t('expiration') }}
                  <span
                    v-if="this.sortOrders['compliance.expiration_date'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th width="120px">{{ $t('notify') }} ({{ $t('days') }})</th>
                <th
                  width="150px"
                  @click="search('compliance.term'), sortBy('compliance.term')"
                >
                  {{ $t('terms') }} ({{ $t('months') }})
                  <span
                    v-if="this.sortOrders['compliance.term'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th width="300px">{{ $t('comments') }}</th>
                <th
                  width="130px"
                  @click="search('compliance.cost'), sortBy('compliance.cost')"
                >
                  {{ $t('cost') }} (USD)
                  <span
                    v-if="this.sortOrders['compliance.cost'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th
                  width="150px"
                  @click="
                    search('compliance.frequency'),
                      sortBy('compliance.frequency')
                  "
                >
                  {{ $t('frequency') }}
                  <span
                    v-if="this.sortOrders['compliance.frequency'] == 1"
                    class="material-icons sm-size"
                    >keyboard_arrow_up</span
                  >
                  <span v-else class="material-icons sm-size"
                    >keyboard_arrow_down</span
                  >
                </th>
                <th width="100px">{{ $t('escalation_rate') }}</th>
                <!--  <th width="100px">{{$t('monthly_fee')}}</th>no trans -->
                <!-- <th width="500px">{{$t('address')}}</th> no trans -->
                <th width="200px">{{ $t('actions') }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <cell-input
                    class="text-left"
                    :value="data[indextr].client_name"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left"
                    :value="data[indextr].facility"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left"
                    :value="data[indextr].type"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left"
                    :value="data[indextr].vendor"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left"
                    :value="data[indextr].title"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <!--  <cell-input class="text-left" :value="data[indextr].document_date" disabled /> -->
                  <cell-input
                    class="text-left"
                    :value="data[indextr].status"
                    :bgColor="data[indextr].status_color"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />

                  <cell-action
                    class="cursor-pointer text-left"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    :disabled="!allowEditing"
                  >
                    <template>
                      <div
                        @click="updateComplianceExpiration(data[indextr])"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      >
                        {{ formatDate(data[indextr].expiration_date) }}
                      </div>
                    </template>
                  </cell-action>

                  <cell-input
                    class="text-left"
                    format="number"
                    :value="data[indextr].notify_days"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left"
                    format="number"
                    :value="data[indextr].term"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <cell-input
                    class="text-left comment-truncate"
                    :value="data[indextr].comments"
                    :id="data[indextr].id"
                    column="comments"
                    @update="updateCell"
                    :max="100"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    :disabled="!allowEditing"
                  />
                  <cell-input
                    class="text-right"
                    type="number"
                    format="decimal"
                    :value="data[indextr].cost"
                    :id="data[indextr].id"
                    column="cost"
                    @update="updateCell"
                    :max="11"
                    prefix="$"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    :disabled="data[indextr].type_id == '14' && allowEditing"
                  />
                  <cell-select
                    @update="updateCell"
                    :id="data[indextr].id"
                    column="frequency"
                    :items="frequencies"
                    :value="{
                      value: data[indextr].frequency,
                      label: data[indextr].frequency_name,
                    }"
                    :keys="{ value: 'id', label: 'name' }"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    :disabled="!allowEditing"
                  />
                  <cell-input
                    class="text-left"
                    :value="formatNumber(data[indextr].escalation_rate)"
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                  />
                  <!-- <cell-input class="text-left" :value="formatNumber(data[indextr].total_monthly_cost)" disabled prefix="$"/> -->
                  <!-- <cell-input class="text-left" :value="data[indextr].address" disabled /> no trans -->
                  <cell-action
                    :tooltip-text="`${data[indextr].facility} - ${data[indextr].client_name} - ${data[indextr].title}`"
                    disabled
                    class="text-center"
                  >
                    <template>
                      <feather-icon
                        @click="validateCompliance(data[indextr])"
                        icon="CheckSquareIcon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        v-if="data[indextr].status_id == 5"
                      />
                      <feather-icon
                        @click="editInsurance(data[indextr])"
                        icon="DollarSignIcon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        v-if="data[indextr].show_detail == '1'"
                      />
                      <feather-icon
                        @click="showCompliance(data[indextr])"
                        icon="ArrowRightCircleIcon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        v-if="data[indextr].show_detail == '1'"
                      />
                      <feather-icon
                        @click="showPdf(data[indextr])"
                        icon="FileTextIcon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      />

                      <delete-compliance
                        v-if="hasPermission(['IU COMPLIANCE DELETE'])"
                        class="mr-4"
                        :id="data[indextr].id"
                      />
                    </template>
                  </cell-action>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="100%">
                    <div
                      v-if="data.length"
                      v-observe-visibility="infiniteHandler"
                    ></div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-row>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleCompliance from '@/store/compliance/moduleCompliance.js'
import AddCompliance from '@/views/apps/compliance/AddCompliance.vue'
import ShowCompliance from '@/views/apps/compliance/ShowCompliance.vue'
import ValidateCompliance from '@/views/apps/compliance/ValidateCompliance.vue'
import DeleteCompliance from '@/views/apps/compliance/DeleteCompliance.vue'
import UpdateComplianceExpiration from '@/views/apps/compliance/UpdateComplianceExpiration.vue'
import CellInput from '@/components/cell-edit/CellInput.vue'
import CellDate from '@/components/cell-edit/CellDate.vue'
import CellSelect from '@/components/cell-edit/CellSelect.vue'
import CellAction from '@/components/cell-edit/CellAction.vue'
import vSelect from 'vue-select'
import PdfViewer from '@/components/pdf/PdfViewer.vue'
import ThSort from '@/views/components/ThSort.vue'

import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'

import general from '@/http/requests/general'
import client from '@/http/requests/client'
import vendor from '@/http/requests/vendor'
import compliance from '@/http/requests/compliance'
import ExportButton from '@/views/components/ExportButton.vue'
import AddButton from '@/views/components/buttons/AddButton.vue'
import EditInsurance from './EditInsurance.vue'
import PdfReader from '@/components/pdf/PdfReader.vue'

export default {
  components: {
    CellInput,
    CellDate,
    CellSelect,
    CellAction,
    'v-select': vSelect,
    AddCompliance,
    ShowCompliance,
    DeleteCompliance,
    PdfViewer,
    UpdateComplianceExpiration,
    ExportButton,
    AddButton,
    ValidateCompliance,
    ThSort,
    EditInsurance,
    PdfReader,
  },
  data() {
    const sortOrders = {}
    const columnas = [
      'c.ClientName',
      'v.VendorName',
      'f.Name',
      'cc.name',
      'ct.name',
      'cs.name',
      'compliance.expiration_date',
      'compliance.term',
      'compliance.cost',
      'compliance.frequency',
    ]
    columnas.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      compliance: {},
      clients: [],
      facilities: [],
      categories: [],
      titles: [],
      frequencies: [],
      currencies: [{ name: 'USD' }, { name: 'MXN' }],
      lastPage: 1,
      params: {
        page: 1,
        search: ' ',
        sortBy: ['compliance.created_at'],
        sort: ['desc'],
      },
      url: '',
      name_report: 'none',
      sortOrders,
      clientFilter: [],
      allowEditing: false,
    }
  },
  computed: {
    complianceList() {
      return this.$store.state.compliance.complianceList
    },
    redirectFilter() {
      return this.$store.state.filter
    },
    vendors() {
      return this.$store.state.compliance.vendors
    },
    allowed_to_see_module() {
      let allowed = localStorage
        .getItem('permissions')
        .includes('IU Compliance Module')
      return allowed
    },
    statusFilterState() {
      return this.$store.state.statusComplianceSelect
    },
    currentFilter() {
      return this.$store.state.filterCompliance
    },
  },
  watch: {
    currentFilter() {
      this.resetFilters()
      this.params.status_id = this.currentFilter ? [this.currentFilter] : []
      this.search()
    },
  },
  created() {
    if (!moduleCompliance.isRegistered) {
      this.$store.registerModule('compliance', moduleCompliance)
      moduleCompliance.isRegistered = true
    }
  },
  beforeMount() {
    this.$store.dispatch('clearGlobalEhsFilter')
  },
  mounted() {
    this.init()
    this.allowEditing = this.hasPermission(['IU COMPLIANCE EDIT'])
    client.list().then((res) => {
      this.clients = res.data.clients
      this.clientFilter.push(...res.data.clients)
    })

    /* compliance.statusList().then(res => {
      this.status = res.data.status
      this.statusFilter.push(...res.data.status)
    }) */

    this.params.status_id = this.currentFilter ? [this.currentFilter] : null
    if (Object.entries(this.redirectFilter).length !== 0) {
      this.params.search = this.redirectFilter.item.id
      this.params.client_id = [this.redirectFilter.item.client_id]
      this.params.status_id = [this.redirectFilter.item.status_id]
    }
    this.search()
  },
  methods: {
    init() {
      this.$store.dispatch('compliance/fetchVendorList')

      general.getFacilities().then((res) => {
        this.facilities = res.data.facilities
      })

      compliance.getCategories().then((res) => {
        this.categories = res.data.categories
      })
      compliance.getTitles().then((res) => {
        this.titles = res.data.titles
      })
      compliance.getFrequencies().then((res) => {
        this.frequencies = res.data.frequencies
      })
      // vendor.list().then(res => {
      //   this.vendors = res.data.vendors
      // })
    },
    filter(array, key, value) {
      return array.filter((item) => item[key] == value)
    },
    search(sortBy = 'compliance.created_at') {
      this.topTableScroll()
      let sort = 'asc'
      if (sortBy == this.params.sortBy) {
        if (this.params.sort[0] == 'asc') {
          sort = 'desc'
        }
      }
      this.params.page = 1
      this.params.sortBy = [sortBy]
      this.params.sort = [sort]

      for (var propName in this.params) {
        if (
          this.params[propName] === null ||
          this.params[propName] === undefined ||
          this.params[propName].length === 0
        ) {
          delete this.params[propName]
        }
      }
      //revisar despues
      this.getComplianceList()
        .then((res) => {
          this.closeLoading()
          if (Object.entries(this.redirectFilter).length !== 0) {
            this.params.search = ''
            this.params.client_id = []
            this.params.status_id = []
            this.$store.dispatch('setFilter', {})
          }
        })
        .catch((err) => this.closeLoading())
    },
    getComplianceList() {
      this.openLoading()
      return this.$store
        .dispatch('compliance/fetchComplianceList', this.params)
        .then((res) => {
          this.lastPage = res.data.last_page
        })
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getComplianceList()
        .then((res) => {
          this.closeLoading()
        })
        .catch((err) => {
          this.closeLoading()
        })
    },
    openLoading() {
      this.$vs.loading({
        container: '#compliance-list-loading',
        scale: 0.6,
      })
    },
    closeLoading() {
      this.$vs.loading.close('#compliance-list-loading > .con-vs-loading')
    },
    sortBy(key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    addCompliance() {
      this.$store.dispatch('toggleSidebar', 'addCompliance')
    },
    showCompliance(compliance) {
      this.compliance = compliance
      this.$store.dispatch('toggleSidebar', 'showCompliance')
    },
    editInsurance(compliance) {
      this.compliance = compliance
      this.$store.dispatch('toggleSidebar', 'edit-insurance')
    },
    showPdf(data) {
      let title = `${data.facility} - ${data.client_name} - ${data.title}`
      let files = []
      if (data.file != null) {
        files.push({
          name: 'Compliance',
          source: BASE_URL + 'storage/' + data.file,
        })
      }
      if (data.insurance_file != null) {//archivo insurance
        files.push({
          name: 'Insurance',
          source: BASE_URL + 'storage/' + data.insurance_file,
      })
      }

      if (files.length == 0) {
        this.$vs.notify({
          color: 'warning',
          title: 'Not File attached',
          text: 'Not File attached',
        })
        return;
      }
      this.$store.dispatch('togglePdfReader', {
        active: true,
        files: files,
        title: title,
      })
    },
    updateComplianceExpiration(compliance) {
      if (this.allowEditing) {
        this.compliance = compliance
        this.$store.dispatch('toggleSidebar', 'updateComplianceExpiration')
      }
    },
    resetFilters() {
      this.params.title_id = []
      this.params.status_id = []
      this.params.client_id = []
      this.search()
    },
    updateCell(e) {
      this.$store
        .dispatch('compliance/update', e)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Updated',
            text: 'Success',
          })
        })
        .catch((err) => {
          if (err.response.status === 422) {
            const error = err.response.data.errors[e.column][0]
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: error,
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: 'Server Error',
            })
          }
        })
    },
    validateCompliance(compliance) {
      this.compliance = compliance
      this.$store.dispatch('toggleSidebar', 'validate-compliance')
    },
    topTableScroll() {
      let elemento = document.getElementsByClassName(
        'vs-con-tbody vs-table--tbody'
      )
      elemento[0].scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>
<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope='row']) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.vx-card__body {
  padding: 10px 0px !important;
}

.vs-table--not-data {
  display: none !important;
}

.sm-size {
  font-size: 12px;
}

.comment-truncate {
  overflow-wrap: break-word;
}

.autocomplete-input {
  width: 100% !important;
  border-radius: 5px;
  border: solid 1px lightgray !important;
  height: 2.7rem;
  font-size: 1rem;
  padding: 5px;
}

.autocomplete-result-list {
  background-color: #fff;
  border: solid 1px lightgray;
  line-height: 2rem;
  cursor: pointer;
  max-height: 10rem;
  overflow: auto;
}

.autocomplete-result-list li {
  padding: 0px 10px;
}

.autocomplete-result-list li:hover {
  background-color: #7167e8;
  background-size: cover;
  color: #ffffff;
  box-sizing: padding-box;
}

.vx-card__title h4 {
  margin-bottom: 2vh;
}
</style>
